import { render, staticRenderFns } from "./DemoPortalButton.vue?vue&type=template&id=46a01350&lang=true"
import script from "./DemoPortalButton.vue?vue&type=script&lang=js"
export * from "./DemoPortalButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports